<script>
import supportedLanguages from "@cclib/dict/supportedLanguages.js";

let {
    value = $bindable("en-US"),
    id = "languageSelect",
    disabled = false,
    class: className = "form-control",
    ariaLabel = undefined,
} = $props();

const languages = supportedLanguages.languages;
const datalistId = $derived(`${id}-options`);
</script>

<input
    type="text"
    {id}
    class={className}
    list={datalistId}
    bind:value
    {disabled}
    aria-label={ariaLabel}
    autocomplete="off"
    spellcheck="false" />
<datalist id={datalistId}>
    {#each languages as languageOption (languageOption)}
        <option value={languageOption}></option>
    {/each}
</datalist>
